<template>
    <div>
        <h3 class="title is-3 has-text-centered">{{ heading }}
            <!--<span v-if="teamId"><br><br>Team goal completion {{ totalPrice | currency }} / {{ teamMonthlyGoal | currency }} ({{teamMonthlyGoalPercent}}%)</span>-->
        </h3>

        <div class="columns is-multiline">
            <div class="column">
                <o-table class="is-responsive is-responsive-xs-desktop"
                         v-if="isTableVisible"
                         :data="processedData"

                         :bordered="table.bordered"
                         :striped="table.striped"
                         :narrowed="table.narrowed"
                         :checkable="false"
                         :mobile-cards="table.mobileCards"
                         :paginated="table.paginated"
                         :pagination-simple="table.paginationSimple"
                         :per-page="12"
                         default-sort="['year', 'desc']"
                >
                    <template>
                        <o-table-column #default="{ row }" field="reimbursable" label="Reimbursable">
                            {{ $filters.yesNo(row.reimbursable) }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="year" label="Year" sortable>
                            {{ row.year }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="month" label="Month" sortable>
                            {{ $filters.valueOrDefault(monthNameByNumber(row.month), '-') }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="qty" label="QTY" sortable>
                            <div @click.prevent="showBilling(row.year, row.month, row.reimbursable)">
                                <a @click.prevent>{{ row.qty }}</a>
                            </div>
                        </o-table-column>
                        <o-table-column #default="{ row }" field="price" label="Amount" sortable>
                            {{ $filters.currency(row.price) }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="monthly_goal" label="Goal" sortable>
                            {{ $filters.valueOrDefault($filters.currency(row.monthly_goal), '-') }}
                        </o-table-column>
                        <o-table-column #default="{ row }" field="monthly_goal_percent" label="Goal Percent" sortable>
                            {{ $filters.valueOrDefault(row.monthly_goal_percent, '-') }}
                        </o-table-column>
                    </template>
                    <template #footer>
                      <th colspan="3">Total</th>
                      <th class="value">{{ totalQuantity }}</th>
                      <th class="value">{{ $filters.valueOrDefault($filters.currency(totalPrice), '-') }}</th>
                      <th>{{ $filters.valueOrDefault($filters.currency(totalMonthlyGoal), '-') }}</th>
                      <th>{{ $filters.valueOrDefault(totalMonthlyPercent, '-') }}</th>
                    </template>
                    <template #empty>
                        <div class="has-text-centered">
                            This table is empty!
                        </div>
                    </template>
                </o-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
import Table from './../../../../mixins/Table'

    export default {
        mixins: [Table],

        props: ['heading', 'data', 'teamId'],

        computed: {
            ...mapGetters(['userNameById', 'userById', 'teamById', 'monthNameByNumber', 'isBillingReimbVisible']),

            processedData() {
                if (!_.isArray(this.data)) {
                    return []
                }

                return _.reduce(this.data, (res, row) => {
                    let monthly_goal_percent = +row.monthly_goal ? (row.monthly_goal ? ((+row.price / +row.monthly_goal) * 100) : 0).toFixed(2) + ' %' : '0 %'

                    res.push({reimbursable: false, year: row.year, month: row.month, qty: row.qty, price: row.price, monthly_goal: row.monthly_goal , monthly_goal_percent})

                    if (this.isBillingReimbVisible) {
                        res.push({reimbursable: true, year: row.year, month: row.month, qty: row.qty_r, price: row.price_r, monthly_goal: '', monthly_goal_percent: ''})
                    }

                    return res
                }, [])
            },

            totalQuantity() {
                return _.sumBy(this.processedData, p => +p.qty)
            },
            totalPrice() {
                return _.sumBy(this.processedData, p=> +p.price)
            },
            totalPriceNoReimbursable() {
                return _.sumBy(_.filter(this.processedData, p=> !p.reimbursable), p=> +p.price)
            },
            totalMonthlyGoal() {
                return _.sumBy(this.processedData, p=> +p.monthly_goal)
            },
            totalMonthlyPercent() {
                return this.totalMonthlyGoal ? ((this.totalPriceNoReimbursable / this.totalMonthlyGoal) * 100).toFixed(2) + ' %' : '0 %'
            },
            teamMonthlyGoalPercent() {
                return this.teamMonthlyGoal ? ((this.totalPrice / this.teamMonthlyGoal) * 100).toFixed(2) : 0
            },

            teamMonthlyGoal() {
                return this.teamId ? this.teamById(this.teamId).monthly_goal : 0
            }
        },

        methods: {
            showBilling(year, month, reimb) {
                this.$emit('row-clicked', year, month, reimb)
            }
        }
    }
</script>